import { createGlobalStyle } from "styled-components";

import MFredWoff from "../fonts/MFred2.0-Regular.woff";
import MFredWoff2 from "../fonts/MFred2.0-Regular.woff2";
// import MFredHeavyWoff from '../fonts/MFred2.0-Heavy.woff';
// import MFredHeavyWoff2 from '../fonts/MFred2.0-Heavy.woff2';

import LoraWoff from "../fonts/Lora-VariableFont_wght.woff";
import LoraWoff2 from "../fonts/Lora-VariableFont_wght.woff2";

export default createGlobalStyle`
    @font-face {
        font-family: 'MFred';
        src: url(${MFredWoff}) format('woff'), url(${MFredWoff2}) format('woff2');
        font-style: normal;
        font-weight: 400;
    }
    @font-face {
        font-family: 'Lora';
        src: url(${LoraWoff}) format('woff'), url(${LoraWoff2}) format('woff2');
        font-style: normal;
        font-weight: 400;
    }
`;
